import axios, { AxiosRequestConfig } from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'
import queryString from 'query-string'

import type {
  FetchCommentsCountResponse,
  RawFetchCommentsResponse,
  RawPostCommentResponse,
  PostCommentRequestBody,
} from './types'
import cookies from 'services/cookies'
import parse from './parse'

const COMMENTS_URL = process.env.COMMENTS_URL

const request = axios.create({
  baseURL: COMMENTS_URL,
})

request.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = cookies.getAccessToken()

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export async function fetchCommentsCount(topicId: string) {
  const response = await request.get<FetchCommentsCountResponse>(
    `topics/${topicId}`,
  )

  return response.data.published_comment_count
}

export async function fetchComments(tileIds: string[]) {
  const params = decamelizeKeys({
    approved: true,
    depth: 0,
    detail: 'full',
    newestFirst: true,
    recurseDepth: 1,
    removed: false,
    tileId: tileIds,
  })

  const query = queryString.stringify(params)
  const response = await request.get(`comments?${query}`).then((response) => {
    return (camelizeKeys(response.data) as unknown) as RawFetchCommentsResponse
  })

  return response.map(parse)
}

export async function postComment(data: PostCommentRequestBody) {
  const { id, ...rest } = data
  const response = await request.post(`topics/${id}/comments`, rest)

  return parse(
    (camelizeKeys(response.data) as unknown) as RawPostCommentResponse,
  )
}

export async function editComment(data: PostCommentRequestBody) {
  const { id, ...rest } = data
  const response = await request.patch(`comments/${id}`, rest)

  return parse(
    (camelizeKeys(response.data) as unknown) as RawPostCommentResponse,
  )
}

export async function postReply(data: PostCommentRequestBody) {
  const { id, ...rest } = data
  const response = await request.post(`comments/${id}/replies`, rest)

  return parse(
    (camelizeKeys(response.data) as unknown) as RawPostCommentResponse,
  )
}
